import { notifications } from '@mantine/notifications';
import { AxiosError } from 'axios';

/**
 * Shows the default error notification using the same logic as the global error handler.
 * Use this when you want to combine custom error handling with the default notification behavior.
 */
export const showDefaultErrorNotification = (error: unknown) => {
  // Don't show error notification if request was cancelled
  if (error && typeof error === 'object' && 'name' in error && error.name === 'CanceledError') {
    return;
  }

  let errorMessage = 'An error occurred';

  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as AxiosError<{ detail?: string }>;
    const status = axiosError.response?.status;

    // Handle specific HTTP status codes with meaningful messages
    if (status === 403) {
      errorMessage = 'Access denied. You do not have permission to perform this action.';
    } else if (status === 404) {
      errorMessage = 'The requested resource was not found.';
    } else if (status === 405) {
      errorMessage = 'This action is not allowed.';
    } else if (axiosError.response?.data?.detail) {
      // Get the first line of the error to show in notification
      errorMessage = axiosError.message + '\n' + (axiosError.response.data.detail.split('\r\n')[0] || axiosError.response.data.detail.split('\n')[0]);
    } else if (axiosError.message) {
      errorMessage = axiosError.message;
    }
  } else if (error && typeof error === 'object' && 'message' in error) {
    errorMessage = (error as Error).message;
  }

  notifications.show({
    title: 'Error',
    message: errorMessage,
    color: 'red',
  });
};